export let keepMount = $store => {
  $store.listen(() => {})
}
